import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPostMenuRequest } from '../models/responseModels'
import { CommonPostResponse } from '../../../components/models/models'

export class UpdateMenuApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/menu/update',
      requesterInfo,
    })
  }

  public async updateMenu(request: IPostMenuRequest): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}
